const commonExceptions = {
    area: 'Common',
    concurrencyFailure: 'ConcurrencyFailure',
    notFound: 'NotFound'
};

export {
    commonExceptions as CommonExceptions
};
